if (!customElements.get("scroll-slider")) {
  customElements.define(
    "scroll-slider",
    class ScrollSlider extends HTMLElement {
      constructor() {
        //console.log('scroll-slider')
        super();
        // set variables
        this.dragPos = { left: 0, x: 0 };
        this.isDragging = false;
        this.enableSliderDragging =
          this.hasAttribute("data-draggable") || false;

        // set references
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.currentPageElement = this.querySelector(
          ".slider-counter--current"
        );
        this.pageTotalElement = this.querySelector(
          ".slider-counter--total"
        );
        // this.prevButton = this.querySelector('button[name="previous"]');
        // this.nextButton = this.querySelector('button[name="next"]');
        this.sliderIndexControl = this.querySelector(".slider-index-control");

        // if (!this.slider || !this.nextButton) return;

        if (!this.slider) return;

        // bind events
        this.bindEvents();

        // init Slide data
        this.initPages();
        const resizeObserver = new ResizeObserver((entries) =>
          this.initPages()
        );
        resizeObserver.observe(this.slider);
      }

      // Bind event handlers
      bindEvents() {
        this.slider.addEventListener("scroll", this.update.bind(this));

        if (this.enableSliderDragging) {
          this.slider.addEventListener(
            "mousedown",
            this.onMouseDown.bind(this)
          );
        }

        // this.prevButton.addEventListener(
        //   "click",
        //   this.onButtonClick.bind(this)
        // );
        // this.nextButton.addEventListener(
        //   "click",
        //   this.onButtonClick.bind(this)
        // );

        if (!this.sliderIndexControl) return;
        this.sliderIndexControlLinks = Array.from(
          this.sliderIndexControl.querySelectorAll(".slider-index")
        );
        this.sliderIndexControlLinks.forEach((link) =>
          link.addEventListener("click", this.linkToSlide.bind(this))
        );
      }

      // Initialize Page/Slide data
      initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter(
          (element) => element.clientWidth > 0
        );
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset =
          this.sliderItemsToShow[1].offsetLeft -
          this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
          (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
            this.sliderItemOffset
        );
        this.totalPages =
          this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
      }

      // Update Slider Navigation Data on init and any scroll event
      update() {
        this.sliderIndexControlButtons = this.querySelectorAll(".slider-index");

        const previousPage = this.currentPage;
        this.currentPage =
          Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
          this.currentPageElement.textContent = this.currentPage;
          this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
          this.dispatchEvent(
            new CustomEvent("slideChanged", {
              detail: {
                currentPage: this.currentPage,
                currentElement: this.sliderItemsToShow[this.currentPage - 1],
              },
            })
          );
        }

        // if (
        //   this.isSlideVisible(this.sliderItemsToShow[0]) &&
        //   this.slider.scrollLeft < 64
        // ) {
        //   this.prevButton.setAttribute("disabled", "disabled");
        // } else {
        //   this.prevButton.removeAttribute("disabled");
        // }

        // if (
        //   this.isSlideVisible(
        //     this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
        //   )
        // ) {
        //   this.nextButton.setAttribute("disabled", "disabled");
        // } else {
        //   this.nextButton.removeAttribute("disabled");
        // }

        if (!this.sliderIndexControlButtons.length) return;

        this.sliderIndexControlButtons.forEach((item, index) => {
          if (this.isSlideVisible(this.sliderItemsToShow[index])) {
            item.setAttribute("disabled", "disabled");
            
            setTimeout(() => {
              item.classList.add("active");
            }, 150);
          } else {
            item.removeAttribute("disabled");
            item.classList.remove("active");
          }
        });
      }

      // Check if a slide is visible
      isSlideVisible(element, offset = 0, wiggleRoom = 64) {
        //console.log(`${this.slider.clientWidth} + ${this.slider.scrollLeft} - ${offset}`)
        const lastVisibleSlide = Math.round(
          this.slider.clientWidth + this.slider.scrollLeft - offset
        );
        //console.log(`Is ${lastVisibleSlide} >= ${element.offsetLeft + element.clientWidth - wiggleRoom}  and also ${element.offsetLeft}  <= ${this.slider.scrollLeft - wiggleRoom}`)
        return (
          element.offsetLeft + element.clientWidth - wiggleRoom <=
            lastVisibleSlide &&
          element.offsetLeft >= this.slider.scrollLeft - wiggleRoom
        );
      }

      // Scroll to a slide
      setActiveSlide(mediaId) {
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        const slideArray = Array.from(this.sliderItems);
        const step = slideArray.indexOf(activeMedia);
        this.slideScrollPosition = step * this.sliderItemOffset;
        this.slider.scrollTo({
          behavior: "smooth",
          left: this.slideScrollPosition,
        });
      }

      // Scroll to a slide
      linkToSlide(event) {
        event.preventDefault();
        const step = this.sliderIndexControlLinks.indexOf(event.currentTarget);
        this.slideScrollPosition = step * this.sliderItemOffset;
        this.slider.scrollTo({
          behavior: "smooth",
          left: this.slideScrollPosition,
        });
      }

      // Handle Previous/Next button click
      onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
          event.currentTarget.name === "next"
            ? this.slider.scrollLeft + step * this.sliderItemOffset
            : this.slider.scrollLeft - step * this.sliderItemOffset;
        this.slider.scrollTo({
          behavior: "smooth",
          left: this.slideScrollPosition,
        });
      }

      // Handle Mouse Down
      onMouseDown(event) {
        this.dragPos = {
          // The current scroll
          left: event.currentTarget.scrollLeft,
          // Get the current mouse position
          x: event.clientX,
        };

        this.isDragging = true;
        this.slider.classList.add("dragging");

        //add event listeners
        document.addEventListener("mousemove", this.onMouseMove.bind(this));
        document.addEventListener("mouseup", this.onMouseUp.bind(this));
      }

      // Handle Mouse Move
      onMouseMove(event) {
        if (!this.isDragging) return;

        // How far the mouse has been moved
        const dx = event.clientX - this.dragPos.x;

        // Scroll the element
        this.slider.scrollLeft = this.dragPos.left - dx;
      }

      // Handle Mouse Up
      onMouseUp(event) {
        this.isDragging = false;
        this.slider.classList.remove("dragging");

        // remove event listeners
        document.removeEventListener("mousemove", this.onMouseMove);
        document.removeEventListener("mouseup", this.onMouseUp);
      }
    }
  );
}